import { Component, type ErrorInfo, type ReactNode } from 'react'

import { captureError } from '@libs/sentry/sentry'

import { Container, Message, ReloadButton, Title } from './RenderErrorBoundary.styled'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

export class RenderErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    captureError(error, { extra: { componentStack: info.componentStack ?? undefined } })
  }

  private handleReload = (): void => {
    window.location.reload()
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <Container>
          <Title>Une erreur est survenue</Title>
          <Message>L&apos;application a rencontré un problème inattendu.</Message>
          <ReloadButton type="button" onClick={this.handleReload}>
            Recharger
          </ReloadButton>
        </Container>
      )
    }
    return this.props.children
  }
}
